module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/coins-dcd5060190624a6e564f68b5d2c42192.svg";